/**
 * Types of alert
 */
const TYPE = {
    SUCCESS: 'success',
    ERROR: 'error'
};

/**
 * States of the alert
 */
const STATES = {
    SHOW: 'show',
    HIDE: 'hide'
};

/**
 * Miliseconds which represents all the stages of the alert life cycle
 */
const MILISECONDS = {
    INITIAL_DELAY: 100,
    SHOW_TIME: 5000,
    REMOVE_TIME: 1000
};

/**
 * Set a new alert element in the HTML body.
 * @param {string} type - type of alert (success or error)
 * @param {string} message - alert message to display
 */
function setElement(type, message) {
    if (!message || !type || (type !== TYPE.SUCCESS && type !== TYPE.ERROR)) {
        return;
    }

    // Hide alerts which can be still active
    $('.hom-notification').addClass(`hom-notification--${STATES.HIDE}`);

    // Alert HTML element
    const $element = $(`<div class="hom-notification hom-notification--${type}"><span>${message}</span></div>`);

    // Attach to HTML body
    $('body').append($element);

    setTimeout(function () {
        // Show the message for X seconds
        setTimeout(function () {
            $element.removeClass(`hom-notification--${STATES.SHOW}`);

            // Remove element after being hidden
            setTimeout(function () {
                $element.remove();
            }, MILISECONDS.REMOVE_TIME);
        }, MILISECONDS.SHOW_TIME);

        // Add a delay to ensure that the animation is not skipped
        $element.addClass(`hom-notification--${STATES.SHOW}`);
    }, MILISECONDS.INITIAL_DELAY);
}

/**
 * Create new JQuery functions using the jquery extend property.
 * @returns {JQuery<Function>} new prototype JQuery function library
 */
$.alert = function () {
    return new (function () {
        /**
         * Show a success alert message.
         * @param {string} message - message to display in the alert
         */
        this.success = function (message) {
            setElement(TYPE.SUCCESS, message);
        };

        /**
         * Show a error alert message.
         * @param {string} message - message to display in the alert
         */
        this.error = function (message) {
            setElement(TYPE.ERROR, message);
        };
    })();
};
